import React from "react"
import ReactTooltip from "react-tooltip"
import { AttributesListItemProps } from "../../../common/types"
import { CUSTOM_ATTRIBUTE_TYPE_SELECT } from "../../../utils"
import "../styles/styles.scss"

const AttributesListItem = (props: AttributesListItemProps) => {
    const requiredMark: JSX.Element = <span className="text-danger small align-top">*</span>
    return (
        <li key={props.id} className="m-0 list-inline-item">
            {props.values?.length === 0 && props.attributeType === CUSTOM_ATTRIBUTE_TYPE_SELECT.value ? ( 
                <>
                    <a href={"#"} data-tip data-for={"anchorLock-anchor" + props.id} onClick={(e) => {
                        e.preventDefault()
                    } }>
                        <small className="custom-form-label">
                            {props.label}
                            {props.required && requiredMark}:
                        </small>
                        <small className="mx-1 text-secondary">
                            {props.displayMessage}{!props.isLastItem && ","}
                        </small>
                    </a>
                    <ReactTooltip
                        place="bottom"
                        className="anchorLock hover-attribute px-3"
                        id={"anchorLock-anchor" + props.id}
                        type="dark"
                        effect="solid"
                        multiline={true}
                    >
                        {props.hoverAttributes}
                    </ReactTooltip>
                </> 
            ) : (
                <>
                    <small className="custom-form-label">
                        {props.label}
                        {props.required && requiredMark}:
                    </small><small className="mx-1 text-secondary">
                        {props.values}{!props.isLastItem && ","}
                    </small>
                </>)
            }
        </li>
    )
}

export default AttributesListItem


// WEBPACK FOOTER //
// ./src/quote/customAttributes/components/AttributesListItem.tsx